import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getUser } from '../../utils/auth';
import ErrorLogCreation from './ErrorLogCreation';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidMount() {
    const { history } = this.props;
    this.unlisten = history.listen((_location, _action) => {
      // Reset state or force a re-render when history changes
      // eslint-disable-next-line react/destructuring-assignment
      if (this.state.hasError) {
        this.setState({ hasError: false });
      }
    });
  }

  componentDidCatch(error, info) {
    const user = getUser();

    this.setState({
      hasError: true,
      errorHandled: false,
      error: {
        message: error.message,
        stack: error.stack,
        info,
      },
      userInfo: user,
    });
  }

  componentWillUnmount() {
    // To prevent memory leak
    this.unlisten();
  }

  onErrorCreated() {
    this.setState({ errorHandled: true });
  }

  goBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  render() {
    const { hasError, errorHandled, error, userInfo } = this.state;
    const { children } = this.props;

    if (hasError) {
      // TODO: Fix text. Try to make better looking
      const errorLogComponent = errorHandled ? null : <ErrorLogCreation error={error} userInfo={userInfo} onErrorCreated={() => this.onErrorCreated(this)} />;
      return (
        <div className="ui container" style={{ marginTop: 50 }}>
          <div className="ui very padded segment">
            <h1 className="ui header">Oj! Något gick fel.</h1>
            <p>Vi beklagar besväret. Du kan prova att:</p>
            <div className="sixteen wide column">
              <button type="button" className="ui button primary" onClick={() => window.location.reload()}>
                Ladda om sidan
              </button>
              <button type="button" className="ui button secondary" onClick={() => this.goBack()}>
                Gå tillbaka
              </button>
            </div>
            <br />
            <div className="sixteen wide column">
              <p>
                Eller kontakta vår support för vidare hjälp:
                {' '}
                <a href="mailto:hej@propida.se">hej@propida.se</a>
              </p>
            </div>
            {errorLogComponent}
          </div>
        </div>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(ErrorBoundary);
